<template>
	<div v-if="hero.slug" class="hero" v-draggable :class="[ animation.name, current.status, 'card-' + hero.slug ]">
		<div class="card-front">
			<div class="bg"></div>
			<div class="illustration"><div class="img"></div></div>
			<div class="frame"></div>
			<div class="value">
				<span class="small">/{{ hero.life_max + hero_life_max_modifier }}</span>
				<span class="main"><span class="icon"></span> {{ hero.life }}</span>
			</div>
			<div class="shield" v-show="hero.shield > 0">{{ hero.shield }}</div>

		</div>
		<div class="animation">
			<div class="cross"></div>
			<div class="blood"></div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import interact from 'interactjs'
import HeroMixin from '@/mixins/hero'

export default {
	name: 'hero',
	mixins: [ HeroMixin ],
	data: function() {
		return {
			animation: {
				name: '',
				value: 0
			}
		}
	},
	props: [ 'hero' ],
	computed: Object.assign(mapGetters([ 'lang', 'current', 'game', 'hero_life_max_modifier' ]), {
		// src: function() {
		// 	return require('@/assets/img/cards/heroes/' + this.hero.slug + '.png')
		// }
	}),
	watch: {
		'current.location': function() {
			this.back_to_position(this.$el)
		},
		'current.level': function() {
			this.back_to_position(this.$el)
		},
		'current.row': function() {
			this.back_to_position(this.$el)
		},
		hero_life_max_modifier: function(newValue, oldValue) {
			if (newValue < oldValue) {
				if (this.hero.life > this.hero.life_max + this.hero_life_max_modifier) {
					this.$store.commit('EDIT_PLAYER_HERO', { life: this.hero.life_max + this.hero_life_max_modifier })
				}
			}
		},
		'hero.life': function(newValue, oldValue) {
			if (!this.animation.name) {
				var self = this
				if (oldValue > newValue) {
					this.animation.name = 'lose-life'
					Sounds.play('hit')
					setTimeout(function() { self.animation.name = '' }, 960)
				}
				else {
					this.animation.name = 'gain-life'
					Sounds.play('heal')
					setTimeout(function() { self.animation.name = '' }, 350)
				}
			}
		},
		'hero.shield': function(newValue, oldValue) {
			if (!this.animation.name) {
				var self = this
				if (oldValue > newValue) {
					this.animation.name = 'lose-shield'
					Sounds.play('shield')
					setTimeout(function() { self.animation.name = '' }, 960)
				}
				else {
					this.animation.name = 'gain-shield'
					Sounds.play('equip')
					setTimeout(function() { self.animation.name = '' }, 350)
				}
			}
		}
	},
	directives: {
		draggable: {
			inserted: function(el, binding, vnode) {
				var self = vnode.context
				interact(el).draggable({
					onstart: function(event) {
						event.target.classList.add('dragging')
						event.target.classList.add('on-top')
					},
					onmove: function(event) {
						var target = event.target
						var x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx
						var y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy

						target.style.webkitTransform = target.style.transform = 'translate(' + x + 'px, ' + y + 'px) scale(1.25)'

						target.setAttribute('data-x', x)
						target.setAttribute('data-y', y)
					},
					onend: function(event) {
						event.target.classList.remove('dragging')
						setTimeout(function() {
							event.target.classList.remove('on-top')
						}, 250)
						if (!event.dropzone) self.back_to_position(event.target)
					}
				})
			}
		}
	}
}
</script>

<style lang="stylus">
@import '../../assets/css/app'
@import '../../assets/css/cards'
@import '../../assets/css/card-heroes'

.game
	.hero
		position absolute
		left (card_width + 8px + 4px)
		bottom 8px
		
.hero
	display block
	width card_width
	height card_height
	color dark
	font-family PearSoda
	font-size 1.6rem
	transition transform 0.5s easeOutQuart
	will-change transform, box-shadow
	z-index 2
	border-radius 6px
	&.ready
		box-shadow 0 0 12px 2px alpha(green, 50%)
	&.dragging
		transition none
		box-shadow 8px 8px 4px alpha(#000, 25%)
	&.on-top
		z-index 11
		// box-shadow 8px 8px 4px alpha(#000, 25%)
	.card-front
		display block
		height 100%
		width 100%
		.bg
			position absolute
			left 3px
			top 3px
			right 3px
			bottom 3px
			// transition 0.25s easeOutQuart
			background card_bg_color
		.frame
			display block
			position absolute
			left 0
			top 0
			right 0
			bottom 0
			background url(../../assets/img/ui/hero-frame.png) center center no-repeat
			background-size 100% 100%
		.illustration
			position absolute
			left 3px
			top 3px
			right 3px
			bottom 3px
			overflow hidden
			.img
				position absolute
				left 50%
				top 50%
				transform translate(-50%, -50%) scale(1)
				background-image url(../../assets/img/cards.png)
				background-repeat no-repeat
		.value
			position absolute
			left 12px
			top 8px
			height 24px
			font-size 3.2rem
			color dark
			color red
			line-height @height
			.main
				float left
				padding-left 18px
				transition 0.35s easeOutQuart
				.icon
					position absolute
					left 0
					top 5px
					width 14px
					height 14px
					background url(../../assets/img/ui/heart.png) center center no-repeat
					background-size 16px 16px
			.small
				margin 0 0 0 2px
				top -8px
				font-size 1.6rem
				color lighten(dark, 50%)
		.shield
			position absolute
			left 12px
			top 32px
			height 24px
			background url(../../assets/img/ui/shield.png) top 4px left no-repeat
			background-size 14px 14px
			padding-left 18px
			transition 0.35s easeOutQuart
			font-size 3.2rem
			color gray
			line-height @height
	.animation
		// display none
		position absolute
		left 50%
		top 50%
		transform translate(-50%, -50%)
		// width 256px
		// height 256px
		width 1px
		height 1px
		> div
			position absolute
			left 0
			top 0
			width 100%
			height 100%
			opacity 0
			background top left no-repeat
			background-size auto 100%
			&.cross
				background-image url(../../assets/img/ui/shards01.png)
				transform scale(0.75)
			&.blood
				background-image url(../../assets/img/ui/hit01.png)
				transform scale(0.75)



.hero
	&.gain-life
		.card-front .value .main
			transform scale(1.25)
	&.gain-shield
		.card-front .shield
			transform scale(1.25)
	&.lose-life
		.card-front
			animation hit_bounce 0.25s easeOutQuart
			.bg
				background #efc3b2
		.animation
			width 256px
			height 256px
			.blood
				opacity 1 !important
				// animation hit 960ms steps(16)
				animation hit_life (960ms / 4) steps(10) forwards
	&.lose-shield
		.card-front
			animation hit_bounce 0.25s easeOutQuart
		.animation
			width 256px
			height 256px
			.cross
				opacity 1 !important
				animation hit_shield (960ms / 4) steps(10) forwards



@keyframes hit_life
	100%
		background-position -(256px * 10) 0

@keyframes hit_shield
	100%
		background-position -(256px * 10) 0

@keyframes hit
	100%
		background-position -(256px * 16) 0

@keyframes hit_bounce 
	50%
		transform scale(0.75)
	100%
		transform scale(1)



</style>
